import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import useInterval from './useInterval';

function useCountdownRedirect(path, seconds, enabled) {
  const [count, setCount] = useState(seconds);
  const history = useHistory();

  const goBack = useCallback(() => {
    history.replace(path)
  }, [path, history])
  
  useInterval(() => {
    if (count - 1 === 0) {
      goBack()
    } else {
      setCount(count => count - 1)
    }
  } , enabled ? 1000 : 10000000)

}

export default useCountdownRedirect;
